<template>
    <div class="stf-card-section" :class="{
        'stf-card-section--footer': footer,
        'stf-card-section--success': success
    }">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
interface Props {
    footer?: boolean;
    success?: boolean;
}

withDefaults(defineProps<Props>(), {
    footer: false,
    success: false
});
</script>

<style scoped lang="scss">
@use '@/assets/sass/_variables' as vars;

.stf-card-section {
  margin: 0 -36px;
  padding: 20px 36px;
  background-color: #F4F4F4;
  border-top: 2px solid rgba(229, 229, 229, 1);
  border-bottom: 2px solid rgba(229, 229, 229, 1);

  // Ensure the section goes from border to border
  width: calc(100% + 72px); // Compensating for the parent's padding
  box-sizing: border-box;

  // Mobile adjustments to match StfCard's responsive behavior
  @media screen and (max-width: 768px) {
    margin: 0 -20px;
    padding: 15px 20px;
    width: calc(100% + 40px); // Compensating for the parent's mobile padding
  }

  &--success {
    background-color: vars.$color-success-light;
  }

  // Footer specific styling
  &--footer {
    margin-bottom: -20px;
    border-bottom: none;

    @media screen and (max-width: 768px) {
      margin-bottom: -15px;
    }
  }
}
</style>
